import { isFetchStatusNone, isFetchStatusPending } from '@neptune/shared/common-domain';
import { BaseLeaderboardEntry, LeaderboardListGroup } from '@neptune/shared/leaderboard-domain';

import {
  leaderboardInitialState,
  LeaderboardsState,
  LeaderboardState,
} from './leaderboards-reducer';

export const getLeaderboardsState = (state: any): LeaderboardsState => {
  return state.leaderboards;
};

export const getLeaderboardState = <T extends BaseLeaderboardEntry>(
  state: any,
  id: string,
): LeaderboardState<T> => {
  return (getLeaderboardsState(state)[id] || leaderboardInitialState) as LeaderboardState<T>;
};

export const areThereAnyLeaderboardEntries = (state: any, id: string): boolean => {
  return getLeaderboardState(state, id).entries.length > 0;
};

export const areThereAnyPendingLeaderboardRequests = (state: any, id: string): boolean => {
  return isFetchStatusPending(getLeaderboardState(state, id).fetchStatus);
};

export const getLeaderboardEntries = <T extends BaseLeaderboardEntry>(
  state: any,
  id: string,
): T[] | undefined => {
  const subState = getLeaderboardState<T>(state, id);
  return isFetchStatusNone(subState.fetchStatus) ? undefined : subState.entries;
};

export const getLeaderboardMatchingItemCount = <T extends BaseLeaderboardEntry>(
  state: any,
  id: string,
): number | undefined => {
  const subState = getLeaderboardState<T>(state, id);
  return isFetchStatusNone(subState.fetchStatus) ? undefined : subState.matchingItemCount;
};

export const getLeaderboardGroups = (
  state: any,
  id: string,
): LeaderboardListGroup[] | undefined => {
  const subState = getLeaderboardState(state, id);

  return isFetchStatusNone(subState.fetchStatus) ? undefined : subState.groups;
};
